<template>
<transition name="modal">
    <div class="modal-mask" >
      <div class="modal-wrapper">
        <div id="modal_contain" class="modal-container">
          <div id="img-container">
          <slot name="body"></slot>
          </div>
          <div class="modal-body" id = 'img_overview'>
            <div class="image-details">
              <div style="display:flex; flex-direction: column; font-family: trim-medium " @mouseleave="clicked()">
                <div>Information: <slot name="image-name" /></div>
                <div class="modal-url">URL Link:
                  <slot name="body1" />
                </div>
                <div>Dimensions: <slot name="dimensions" /></div>
                <div>Size: <slot name="size" /></div>
                <div>Tags: <slot name="body2" /></div>
              </div>
              <div style="align-self: center;">
                <!-- <button class="modal-button" @click="$emit('close')"> CLOSE X</button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  export default {
    props:{
      offset : {
        type: Object,
      }
    },
    mounted(){
      let offsetY = window.scrollY-400;
      let offsetX = this.offset.x;

      if (window.matchMedia("(max-width: 1600px)").matches) {
        if(offsetX > 993){
          offsetX = 992;
        }
      }
      if (window.matchMedia("(max-width: 1500px)").matches) {
        if(offsetX > 786){
          offsetX = 785;
        }
      }
      if (window.matchMedia("(max-width: 1400px)").matches) {
        if(offsetX > 755){
          offsetX = 754;
        }
      }
      if (window.matchMedia("(max-width: 1280px)").matches) {
        if(offsetX > 687){
          offsetX = 686;
        }
      }
      if (window.matchMedia("(max-width: 1080px)").matches) {
        if(offsetX > 493){
          offsetX = 492;
        }
      }
      if (window.matchMedia("(max-width: 1020px)").matches) {
        if(offsetX > 468){
          offsetX = 467;
        }
      }


      let modal_var = document.getElementById("modal_contain");
      modal_var.style.position = 'relative';
      modal_var.style.left = offsetX + 'px';
      modal_var.style.top = (this.offset.y+offsetY) + 'px';

    },
      methods: {
        clicked() {
            this.$emit("mouseleave");
        }
      }
  }
</script>
<style scoped>
.modal-mask {
  position: absolute;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  max-width: 500px;
  margin: 0px auto;
  /* padding: 20px 30px; */
  border-radius: 2px;
  transition: all 0.3s ease;
  font-family: "trim-light";
  display: flex;
  flex-direction: column;
  gap: 0;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  width: 500px;
  display: flex;
  flex-direction: column;

}

  @media only screen and (max-width: 768px) {
    .modal-body {
    width: 355px;
    }
  }

  @media only screen and (max-width: 600px) {
    .modal-body {
    width: 80vw;
    }
  }

.image-details {
  display: flex;
  text-transform: capitalize;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 25px;
  line-height: 1.8;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.modal-button {
  width: 100px;
  height: 50px;
  background-color: #B65A02;
  border: none;
  color: white;
  cursor: pointer;
  align-items: center;
  outline: none;
}

.modal-url {
  width: 500px;
  text-overflow: ellipsis;
  overflow: hidden;
}

@media only screen and (max-width: 768px) {
  .modal-url {
    width: 306px;
  }
}

@media only screen and (max-width: 600px) {
  .modal-url {
    width: 65vw;
  }
}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>